/*
 * @Author: Json Chen
 * @Date: 2021-07-20 13:18:39
 * @LastEditTime: 2021-10-13 17:17:15
 * @LastEditors: Teemo Ding
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/request/settings/logistics/packingslip.ts
 */
import { get, post, remove } from 'src/tools/server';

export const getPackingSlip = (warehouseUuid) =>
  get<any>(`/portal/setting/store/packingSlipPage/${warehouseUuid}`, {});

export const setPackingSlip = (body: any) =>
  post<any>(`/portal/setting/store/packingSlip`, body, {});

export const delPackingSlip = (packingSlipUuid) =>
  remove<any>(`/portal/setting/store/packingSlip/${packingSlipUuid}`, {});

export const getPackingSlip2 = (warehouseUuid) =>
  get<any>(`/portal/setting/store/packingSlip/${warehouseUuid}`, {});
